import React from "react";
import "./ImageSlider.css";
import Image1 from "../../../src/assets/ImageSlider/0001.jpeg";
import Image2 from "../../../src/assets/ImageSlider/2.jpg";
import Image3 from "../../../src/assets/ImageSlider/newfolder.jpg";
import Image4 from "../../../src/assets/ImageSlider/Slider-1.jpg";
import Image5 from "../../../src/assets/ImageSlider/Slider-6.jpg";
import Image6 from "../../../src/assets/ImageSlider/Slider.jpg";
import Image7 from "../../../src/assets/ImageSlider/Solar-2022.jpg";

export default function ImageSlider() {
  function tag(event) {
    document.querySelectorAll(".imageSLides11").forEach((elem) => {
      elem.className = "imageSLides11";
    });

    event.currentTarget.className =
      "imageSLides11 activeofSlides anotheractive";
  }

  return (
    <>
      <div className="container-fluid Imageslidercolor">
        <div className="container-fluid bg-transparent">
          <div className="row">
            <div className="col-lg-7 col-sm-12">
              <h1>BUILD A BETTER FUTURE</h1>
            </div>
            <div className="col-lg-5 col-sm-12">
              <p>
                Innovators, changemakers and thought leaders—you’ll find them
                all at Meta.
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid bg-transparent SliderMain d-flex justify-content-center  py-4 ">
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image1})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image2})` }}
            className="imageSLides11 activeofSlides anotheractive"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image3})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image4})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image5})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image6})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
          <div
            onClick={tag}
            style={{ backgroundImage: `url(${Image7})` }}
            className="imageSLides11"
          >
            <div className="displayOfContent displayShow">
              <button className="btn bg-transparent text-white">
                Readmore
              </button>
              <p className="listofP text-white fs-3 w-75 py-5 px-3 ">
                "We all share responsibility in helping shape the future."
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
